import React, { useState, lazy } from 'react';
import { StickyBars } from '../components/StickyBars';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
import { CheckCircle2, ChevronDown, ShieldCheck, Star } from 'lucide-react';
const CHECKOUT_MEGAPACK = 'https://checkout.cherubagency.com/cart/56596791329092:1';
const CHECKOUT_SAGA1 = 'https://checkout.cherubagency.com/cart/56548565877060:1';
const CHECKOUT_14_97 = 'https://checkout.cherubagency.com/cart/56548565877060:1';
const CHECKOUT_23_97 = 'https://checkout.cherubagency.com/cart/56596791329092:1';
const CHECKOUT_URL = CHECKOUT_MEGAPACK;
const BuyButtons = () => <div className="flex flex-col items-center gap-4 w-full max-w-2xl mx-auto mt-8" data-id="element-17">
    <a href={CHECKOUT_URL} className="w-full bg-brand-gold hover:bg-yellow-500 text-brand-black font-black text-lg md:text-2xl py-5 px-8 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.4)] hover:shadow-[0_0_40px_rgba(201,168,76,0.6)] transition-all transform hover:scale-105 text-center flex flex-col items-center" data-id="element-18">
      <span data-id="element-19">👉 QUIERO EL SISTEMA COMPLETO — 23,97€</span>
      <span className="text-sm md:text-base font-semibold mt-1 opacity-90" data-id="element-20">
        10 tomos + 6 bonos · Acceso inmediato · Garantía 30 días
      </span>
    </a>

    <a href={CHECKOUT_SAGA1} className="w-full border-2 border-brand-gold/50 hover:border-brand-gold text-brand-gold font-bold text-base md:text-lg py-4 px-8 rounded-xl transition-all text-center flex flex-col items-center bg-brand-black/50 hover:bg-brand-gold/10" data-id="element-21">
      <span data-id="element-22">→ Empezar solo con la Saga 1 — 14,97€</span>
      <span className="text-xs md:text-sm font-normal mt-1 text-brand-gray" data-id="element-23">
        ✔ Descarga inmediata · ✔ Un solo pago · ✔ Tuyo para siempre
      </span>
    </a>
  </div>;
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-brand-gold/20" data-id="element-24">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none" data-id="element-25">
        <span className="font-bold text-lg text-brand-white pr-4" data-id="element-26">
          {question}
        </span>
        <ChevronDown className={`w-6 h-6 text-brand-gold transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-27" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-28">
        <div className="text-brand-gray space-y-4" data-id="element-29">{answer}</div>
      </div>
    </div>;
};
export function SalesPage() {
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-30">
      <MetaPixel data-id="element-31" />
      <StickyBars data-id="element-32" />
      <SocialProofPopup data-id="element-33" />

      {/* SECCIÓN 1 — HERO */}
      <section className="pt-10 pb-8 px-4 bg-brand-black relative overflow-hidden" data-id="element-34">
        <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-35">
          <h1 className="text-3xl md:text-5xl font-black leading-tight mb-6 tracking-tight" data-id="element-36">
            Tu cerebro{' '}
            <span className="text-brand-gold whitespace-nowrap" data-id="element-37">
              no está roto.
            </span>
            <br data-id="element-38" />
            Nunca tuviste las herramientas correctas.
          </h1>

          <a href={CHECKOUT_URL} className="block cursor-pointer transform hover:scale-105 transition-transform duration-300 mb-6" data-id="element-39">
            <img src="https://cdn.magicpatterns.com/uploads/aQuxTkgZJM15WjoKcbB1rt/MOKUP_FINAL.png" alt="SIN LÍMITES - TDAH para Emprendedores" className="w-full max-w-sm mx-auto rounded-xl shadow-2xl border border-brand-gold/20" fetchpriority="high" width={1536} height={1024} decoding="async" style={{
            aspectRatio: '3/2',
            contentVisibility: 'auto'
          }} data-id="element-40" />
          </a>

          <p className="text-base md:text-lg text-brand-gray leading-relaxed mb-6" data-id="element-41">
            El primer sistema basado en neurociencia diseñado para que el
            emprendedor con TDAH pase del caos creativo a los proyectos
            terminados.
          </p>

          <p className="text-sm md:text-base text-brand-gold font-bold mb-6" data-id="element-42">
            Creado por un emprendedor con TDAH.
            <br data-id="element-43" />
            Para emprendedores con TDAH.
          </p>

          {/* Primary CTA */}
          <a href={CHECKOUT_URL} className="block w-full bg-brand-gold hover:bg-yellow-500 text-brand-black font-black text-base md:text-xl py-4 px-6 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.4)] transition-all text-center mb-3" data-id="element-44">
            👉 QUIERO EL SISTEMA COMPLETO — 23,97€
          </a>

          {/* Secondary CTA */}
          <a href={CHECKOUT_SAGA1} className="block w-full border-2 border-brand-gold/50 hover:border-brand-gold text-brand-gold font-bold text-sm md:text-base py-3 px-6 rounded-xl transition-all text-center mb-4 bg-brand-black/50" data-id="element-45">
            → Empezar con la Saga 1 — 14,97€
          </a>

          {/* Trust badges */}
          <p className="text-xs text-brand-gray" data-id="element-46">
            ✔ Descarga inmediata · ✔ Un solo pago · ✔ Tuyo para siempre
          </p>
        </div>
      </section>

      {/* SECCIÓN 2 — EL MOMENTO DE RECONOCIMIENTO (White bg for high contrast reading) */}
      <section className="py-24 px-4 bg-brand-white text-brand-black" data-id="element-47">
        <div className="max-w-3xl mx-auto" data-id="element-48">
          <h2 className="text-3xl md:text-5xl font-black mb-12 leading-tight" data-id="element-49">
            Hay una pregunta que
            <br data-id="element-50" />
            muchos emprendedores con TDAH
            <br data-id="element-51" />
            se hacen cuando nadie los escucha.
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-gray-800 leading-relaxed font-medium" data-id="element-52">
            <p className="text-2xl md:text-3xl font-bold text-brand-gold italic" data-id="element-53">
              "¿Por qué no puedo simplemente funcionar?"
            </p>
            <p data-id="element-54">
              No es que no quieras. No es que no tengas capacidad. No es que no
              te importe tu negocio.
            </p>
            <p data-id="element-55">
              Tienes ideas que valen dinero. Tienes días donde produces más en 3
              horas que otros en una semana entera. Tienes una visión clara de
              lo que quieres construir.
            </p>
            <p className="font-bold text-black" data-id="element-56">Y también tienes lo otro.</p>
            <p data-id="element-57">
              Los proyectos que llevan meses al 80%. Las semanas que empiezan
              con el planning perfecto y terminan igual que la anterior. Los
              métodos que funcionan 4 días y se caen solos el quinto.
            </p>
            <p data-id="element-58">
              El cliente importante al que nunca llamas porque algo en tu cabeza
              lo bloquea. El producto que llevas meses "casi listo." El negocio
              que existe en tu mente con detalle pero que en la realidad avanza
              a trompicones.
            </p>
            <p data-id="element-59">Y el viernes llega. Y está la misma pregunta de siempre.</p>
            <p className="font-bold text-black" data-id="element-60">"Esta semana también."</p>
            <p data-id="element-61">Lo más duro no es el caos.</p>
            <p data-id="element-62">
              Lo más duro es saber que puedes dar más. Saberlo con certeza. Y no
              entender por qué no ocurre.
            </p>
            <p className="text-2xl font-bold text-black mt-12" data-id="element-63">
              Porque nadie te explicó que los sistemas que usas no están
              diseñados para tu cerebro.
            </p>
            <p className="text-xl font-bold text-brand-gold" data-id="element-64">
              Nunca lo estuvieron.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 3 — EL DIAGNÓSTICO REAL */}
      <section className="py-24 px-4 bg-brand-black border-t border-brand-gold/20" data-id="element-65">
        <div className="max-w-3xl mx-auto" data-id="element-66">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-67">
            El problema no eres tú.
            <br data-id="element-68" />
            <span className="text-brand-gold" data-id="element-69">
              Es que llevas años usando las herramientas equivocadas.
            </span>
          </h2>

          <p className="text-xl text-brand-gray mb-12" data-id="element-70">
            Cada método de productividad que existe fue diseñado para un cerebro
            con: Regulación emocional estable. Motivación que no depende de la
            dopamina. Memoria de trabajo alta. Tolerancia natural a esperar
            resultados.
            <br data-id="element-71" />
            <br data-id="element-72" />
            <span className="text-brand-white font-bold" data-id="element-73">
              El cerebro TDAH no tiene ninguna de las cuatro.
            </span>
            <br data-id="element-74" />
            <br data-id="element-75" />Y sin embargo llevas años intentando aplicar exactamente esos
            métodos. El resultado lo conoces:
          </p>

          <div className="bg-brand-dark p-8 rounded-2xl border border-brand-gold/20 mb-12 space-y-4" data-id="element-76">
            {['Empiezas con energía brutal y abandonas al 80%', 'Tienes 7 proyectos abiertos y ninguno terminado', 'Los métodos que probaste no duraron más de 2 semanas', 'Sabes lo que tienes que hacer pero no puedes arrancar', 'Trabajas muchas horas y al final del día no sabes qué avanzó', 'Quieres ser consistente pero no sabes cómo hacerlo con este cerebro', 'Cuando algo sale bien, el impostor dice que fue suerte', 'Cuando algo sale mal, llevas días sin recuperarte emocionalmente'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-77">
                <div className="w-6 h-6 rounded border-2 border-brand-gold flex-shrink-0 mt-1" data-id="element-78"></div>
                <p className="text-lg text-brand-white" data-id="element-79">{item}</p>
              </div>)}
          </div>

          <div className="space-y-6 text-lg text-brand-gray" data-id="element-80">
            <p className="text-2xl font-bold text-brand-white" data-id="element-81">
              ¿Cuántos has marcado?
            </p>

            <div className="text-xl text-brand-white font-bold leading-relaxed" data-id="element-82">
              <p data-id="element-83">Si marcaste 3 o más, escucha esto:</p>
              <p className="mt-4" data-id="element-84">No es tu actitud.</p>
              <p data-id="element-85">No es tu carácter.</p>
              <p data-id="element-86">No es que no sirvas para esto.</p>
              <p className="mt-4" data-id="element-87">
                Es que llevas años usando
                <br data-id="element-88" />
                <span className="text-brand-gold" data-id="element-89">el software equivocado</span>
                <br data-id="element-90" />
                para tu hardware.
              </p>
              <p className="mt-4 text-brand-gray font-normal" data-id="element-91">
                Y nadie te dio el manual correcto.
              </p>
              <p className="text-brand-gold" data-id="element-92">Hasta hoy.</p>
            </div>

            <p data-id="element-93">
              Y la pregunta silenciosa que crece:{' '}
              <span className="text-brand-white italic" data-id="element-94">
                "¿Seré capaz de construir algo real con este cerebro?"
              </span>
            </p>
            <p className="text-2xl font-bold text-brand-white mt-8" data-id="element-95">
              La respuesta es sí. Pero no con los métodos que estás usando.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 — POR QUÉ ESTE SISTEMA ES DIFERENTE */}
      <section className="py-24 px-4 bg-brand-dark" data-id="element-96">
        <div className="max-w-4xl mx-auto text-center" data-id="element-97">
          <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-98">
            La mayoría de sistemas empiezan por fuera.
            <br data-id="element-99" />
            <span className="text-brand-gold" data-id="element-100">Este empieza por dentro.</span>
          </h2>

          <div className="text-lg md:text-xl text-brand-gray space-y-6 max-w-3xl mx-auto text-left" data-id="element-101">
            <p data-id="element-102">
              No porque sea más "espiritual." Porque es lo único que funciona
              con este cerebro.
            </p>
            <p className="text-brand-white font-bold" data-id="element-103">
              Instalar sistemas de productividad sobre un sistema interno
              inestable produce sistemas que duran 2 semanas. Lo has vivido.
            </p>
            <p data-id="element-104">
              Funcionan mientras la motivación aguanta. Y cuando cae, el sistema
              se cae con ella. No porque seas incapaz. Porque construiste sobre
              cimientos agrietados.
            </p>
            <p className="text-2xl font-bold text-brand-gold mt-12 mb-6 text-center" data-id="element-105">
              SIN LÍMITES invierte el orden.
            </p>

            <div className="grid md:grid-cols-2 gap-8 mt-8" data-id="element-106">
              <div className="bg-brand-black p-8 rounded-2xl border border-brand-gold/30" data-id="element-107">
                <h3 className="text-2xl font-bold text-brand-white mb-4" data-id="element-108">
                  Saga 1: Los cimientos
                </h3>
                <p data-id="element-109">
                  La identidad. El autosabotaje. Las emociones. El sistema
                  nervioso. La dopamina.
                </p>
              </div>
              <div className="bg-brand-black p-8 rounded-2xl border border-brand-gold/30" data-id="element-110">
                <h3 className="text-2xl font-bold text-brand-white mb-4" data-id="element-111">
                  Saga 2: La ejecución
                </h3>
                <p data-id="element-112">
                  La semana diseñada. El hiperfoco bajo demanda. Los proyectos
                  que se terminan. El negocio que avanza.
                </p>
              </div>
            </div>

            <p className="text-center mt-12 text-xl" data-id="element-113">
              Cuando el interior está sólido, la productividad deja de ser una
              batalla.
              <br data-id="element-114" />
              <br data-id="element-115" />
              Se convierte en un sistema. Que funciona aunque no tengas ganas.
              Que funciona en los días buenos y en los días difíciles. Que
              funciona con el cerebro que tienes.
              <br data-id="element-116" />
              <br data-id="element-117" />
              <span className="text-brand-gold font-bold text-2xl" data-id="element-118">
                No con el que crees que deberías tener.
              </span>
            </p>
          </div>

          <div className="mt-16" data-id="element-119">
            <BuyButtons data-id="element-120" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 & 7 — LAS SAGAS EN DETALLE */}
      <section className="py-24 px-4 bg-brand-black" data-id="element-121">
        <div className="max-w-4xl mx-auto" data-id="element-122">
          {/* SAGA 1 */}
          <div className="mb-24" data-id="element-123">
            <div className="text-center mb-12" data-id="element-124">
              <h2 className="text-4xl md:text-5xl font-black mb-4 text-brand-gold" data-id="element-125">
                🛡️ SAGA 1: LA RECONSTRUCCIÓN INTERNA
              </h2>
              <p className="text-xl text-brand-white font-bold mb-8" data-id="element-126">
                Los cimientos que hacen posible todo lo demás
              </p>

              <a href={CHECKOUT_URL} className="block cursor-pointer transform hover:scale-105 transition-transform duration-300" data-id="element-127">
                <img src="https://cdn.magicpatterns.com/uploads/apf6tdgTMi5cuoxaS4ecEh/S1.png" alt="Saga 1" className="w-full max-w-xl mx-auto rounded-2xl shadow-2xl border border-brand-gold/20 mb-8" loading="lazy" decoding="async" width={1024} height={1536} data-id="element-128" />
              </a>

              <p className="text-lg text-brand-gray max-w-2xl mx-auto" data-id="element-129">
                Antes de hablar de productividad, hay algo más urgente que
                resolver. La relación que tienes con tu propio cerebro.
              </p>
            </div>

            <div className="space-y-6" data-id="element-130">
              {[{
              title: 'Tomo 1 — Identidad sin Límites',
              dolor: 'Años de mensajes de que tu cerebro es el problema construyeron una historia sobre ti que no es verdad. Pero que actúa como si lo fuera.',
              solucion: 'Una identidad construida desde evidencia real. No desde afirmaciones vacías. Desde lo que ya demostraste ser. El registro que hace imposible ignorar quién eres. La declaración que releas cuando el impostor aparece.'
            }, {
              title: 'Tomo 2 — El Cerebro Anti-Autosabotaje',
              dolor: "Siempre te boicoteas justo cuando más cerca estás. El proyecto que se abandona al 90%. La propuesta que 'se olvidó' enviar. El cliente importante que nunca se llama.",
              solucion: 'Los 6 patrones de autosabotaje específicos del TDAH. Tu mapa de señales de alerta personales. El protocolo de interrupción de 90 segundos. Tu plan diseñado para tu patrón específico.'
            }, {
              title: 'Tomo 3 — Regulación Emocional para Emprendedores',
              dolor: 'Tomas decisiones de negocio bajo emoción intensa y las lamentas después. El cliente que no respondió y pasaste el día en espiral. La crítica que duró 3 días en tu cabeza. La negociación donde bajaste el precio por la ansiedad.',
              solucion: 'Tu ventana de tolerancia personal. El protocolo de regulación en tiempo real. La regla del estado emocional para decisiones importantes. Las 4 emociones que más cuestan negocio: gestionadas.'
            }, {
              title: 'Tomo 4 — Sistema Nervioso y Rendimiento',
              dolor: 'Días brillantes y días donde no puedes hacer nada. Sin saber por qué. Sin saber cuándo vuelve el modo ON. Viviendo a merced de cómo amaneces.',
              solucion: 'El protocolo diario con 5 anclas de sistema nervioso sano. Tu diagnóstico de sueño y cronótipo real. El sistema de recuperación activa que no depende de la motivación. El protocolo de emergencia cuando el sistema colapsa.'
            }, {
              title: 'Tomo 5 — Dopamina Inteligente',
              dolor: 'Sabes que deberías hacer algo y no puedes activarte para hacerlo. Procrastinas en lo que más importa. Y haces con facilidad lo que no importa.',
              solucion: 'Por qué la motivación no funciona como te dijeron. Tu menú de recompensas constructivas. El mapa de conexión: objetivo a largo plazo → acción de hoy. Un sistema de dopamina que impulsa lo que construyes.'
            }].map((tomo, i) => <div key={i} className="bg-brand-dark p-6 md:p-8 rounded-2xl border border-brand-gold/10 hover:border-brand-gold/40 transition-colors" data-id="element-131">
                  <h3 className="text-2xl font-bold text-brand-gold mb-4" data-id="element-132">
                    🔹 {tomo.title}
                  </h3>
                  <div className="space-y-4" data-id="element-133">
                    <p data-id="element-134">
                      <span className="text-red-400 font-bold" data-id="element-135">
                        El dolor que resuelve:
                      </span>{' '}
                      <span className="text-brand-gray" data-id="element-136">{tomo.dolor}</span>
                    </p>
                    <p data-id="element-137">
                      <span className="text-green-400 font-bold" data-id="element-138">
                        Lo que consigues:
                      </span>{' '}
                      <span className="text-brand-white" data-id="element-139">{tomo.solucion}</span>
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* SAGA 2 */}
          <div data-id="element-140">
            <div className="text-center mb-12" data-id="element-141">
              <h2 className="text-4xl md:text-5xl font-black mb-4 text-brand-gold" data-id="element-142">
                🚀 SAGA 2: LA MÁQUINA DE EJECUCIÓN
              </h2>
              <p className="text-xl text-brand-white font-bold mb-8" data-id="element-143">
                La estructura de guerra cuando los cimientos ya están sólidos
              </p>

              <a href={CHECKOUT_URL} className="block cursor-pointer transform hover:scale-105 transition-transform duration-300" data-id="element-144">
                <img src="https://cdn.magicpatterns.com/uploads/p1k6KLd4kR321wiPsPsXw3/S2.png" alt="Saga 2" className="w-full max-w-xl mx-auto rounded-2xl shadow-2xl border border-brand-gold/20 mb-8" loading="lazy" decoding="async" width={1024} height={1536} data-id="element-145" />
              </a>

              <p className="text-lg text-brand-gray max-w-2xl mx-auto" data-id="element-146">
                Con el sistema interno trabajado, la productividad cambia de
                naturaleza. Deja de ser una batalla contra ti mismo. Se
                convierte en un sistema.
              </p>
            </div>

            <div className="space-y-6" data-id="element-147">
              {[{
              title: 'Tomo 1 — Desintoxicación de Dopamina',
              dolor: "El scroll te roba el día y sabes que lo hace pero no puedes parar. Las mañanas que empiezan con 'solo miro un momento' y terminan 2 horas después sin haber empezado nada.",
              solucion: 'Las fuentes exactas de dopamina barata que bloquean tu ejecución. Protocolo de 7 días. Día por día. Fricción inteligente sin prohibiciones absolutas. Un entorno que trabaja a tu favor en lugar de contra ti.'
            }, {
              title: 'Tomo 2 — Sistemas de Disciplina',
              dolor: "Empiezas fuerte el lunes. El jueves no sabes cómo llegaste aquí. El viernes ya es 'el lunes que viene.'",
              solucion: 'La semana diseñada antes de que empiece. Las 4 reglas binarias que se cumplen solas. El sistema mínimo que funciona en los días malos. El ciclo semanal de revisión en 15 minutos.'
            }, {
              title: 'Tomo 3 — Hiperfoco bajo Demanda',
              dolor: 'Entras en hiperfoco por accidente. Siempre en lo que no toca. Llevas horas en algo irrelevante y no puedes arrancar en lo que importa.',
              solucion: 'Los 3 tipos de hiperfoco y cuándo usar cada uno. Las condiciones exactas que lo activan en tu cerebro. Protocolo de activación de 10–15 minutos. El estado donde produces 4 veces más. Por diseño.'
            }, {
              title: 'Tomo 4 — Ejecución Imparable',
              dolor: '7 proyectos abiertos. Ninguno terminado. La sensación de estar siempre ocupado pero nunca avanzando de verdad.',
              solucion: 'Sistema de carriles: Activo / Próximo / Pausa / Archivo. El método de tarea única implementado. El filtro de las 3 preguntas para decidir qué va primero. El ciclo semanal que mantiene el momentum.'
            }, {
              title: 'Tomo 5 — Finalización Eficaz',
              dolor: "Siempre al 80–90% de todo. El producto que lleva meses 'casi listo.' El proyecto que nunca llega al mundo. El último kilómetro que el TDAH siempre abandona.",
              solucion: 'El criterio de terminado para cada tipo de proyecto. El protocolo de finalización en 3 fases. El sistema de cierres que construye la identidad del finalizador. Los proyectos que empiezas llegan al mundo.'
            }].map((tomo, i) => <div key={i} className="bg-brand-dark p-6 md:p-8 rounded-2xl border border-brand-gold/10 hover:border-brand-gold/40 transition-colors" data-id="element-148">
                  <h3 className="text-2xl font-bold text-brand-gold mb-4" data-id="element-149">
                    🔹 {tomo.title}
                  </h3>
                  <div className="space-y-4" data-id="element-150">
                    <p data-id="element-151">
                      <span className="text-red-400 font-bold" data-id="element-152">
                        El dolor que resuelve:
                      </span>{' '}
                      <span className="text-brand-gray" data-id="element-153">{tomo.dolor}</span>
                    </p>
                    <p data-id="element-154">
                      <span className="text-green-400 font-bold" data-id="element-155">
                        Lo que consigues:
                      </span>{' '}
                      <span className="text-brand-white" data-id="element-156">{tomo.solucion}</span>
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 8 — ANTES VS DESPUÉS */}
      <section className="py-24 px-4 bg-brand-white text-brand-black" data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          <h2 className="text-3xl md:text-5xl font-black mb-12 text-center" data-id="element-159">
            🔄 Lo que cambia cuando tienes el sistema correcto
          </h2>

          <div className="overflow-x-auto" data-id="element-160">
            <table className="w-full text-left border-collapse" data-id="element-161">
              <thead data-id="element-162">
                <tr data-id="element-163">
                  <th className="p-4 md:p-6 bg-red-50 text-red-700 font-bold text-lg md:text-xl border-b-2 border-red-200 w-1/2" data-id="element-164">
                    ❌ Sin el sistema
                  </th>
                  <th className="p-4 md:p-6 bg-green-50 text-green-700 font-bold text-lg md:text-xl border-b-2 border-green-200 w-1/2" data-id="element-165">
                    ✅ Con el sistema
                  </th>
                </tr>
              </thead>
              <tbody className="text-base md:text-lg" data-id="element-166">
                {[['Te culpas por cómo funciona tu cerebro', 'Entiendes cómo funciona y lo usas'], ['Proyectos eternamente al 80%', 'Proyectos que cruzan la línea de verdad'], ['Métodos que duran 2 semanas', 'Un sistema diseñado para tu neurología'], ['Hiperfoco por accidente en lo que no toca', 'Hiperfoco activado cuando importa'], ['Días ON y días OFF sin explicación', 'Sistema nervioso que se sostiene'], ['Motivación que viene y va sin control', 'Motivación diseñada, no esperada'], ['Semanas que se repiten sin avance', 'Momentum que se acumula'], ['Decisiones tomadas bajo emoción intensa', 'Decisiones desde claridad real'], ['El negocio existe solo en tu cabeza', 'El negocio se construye en la realidad']].map((row, i) => <tr key={i} className="border-b border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-167">
                    <td className="p-4 md:p-6 text-gray-600" data-id="element-168">{row[0]}</td>
                    <td className="p-4 md:p-6 font-bold text-brand-black" data-id="element-169">
                      {row[1]}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* INSERCIÓN #3 — Transición tabla → bonos */}
      <section className="py-16 px-4 bg-brand-black text-center" data-id="element-170">
        <div className="max-w-3xl mx-auto" data-id="element-171">
          <p className="text-xl md:text-2xl text-brand-gray leading-relaxed" data-id="element-172">
            Esa columna de la derecha no es una promesa.
            <br data-id="element-173" />
            <span className="text-brand-white font-bold" data-id="element-174">
              Es el resultado de tener el sistema correcto.
            </span>
            <br data-id="element-175" />
            <br data-id="element-176" />
            Y ese sistema está en los 10 tomos
            <br data-id="element-177" />
            que acabas de ver.
            <br data-id="element-178" />
            <br data-id="element-179" />
            <span className="text-brand-gold font-bold" data-id="element-180">
              Más los 6 bonos diseñados para que
              <br data-id="element-181" />
              el conocimiento no se quede en teoría.
            </span>
          </p>
        </div>
      </section>

      {/* SECCIÓN 9 — LOS BONOS */}
      <section className="py-24 px-4 bg-brand-dark" data-id="element-182">
        <div className="max-w-5xl mx-auto" data-id="element-183">
          <div className="text-center mb-16" data-id="element-184">
            <h2 className="text-4xl md:text-5xl font-black mb-4 text-brand-gold" data-id="element-185">
              🎁 LOS BONOS EXCLUSIVOS
            </h2>
            <p className="text-xl text-brand-white font-bold bg-brand-gold/20 inline-block px-6 py-2 rounded-full" data-id="element-186">
              Gratis por el día de hoy
            </p>
          </div>

          {/* Bonos Saga 1 */}
          <div className="mb-20" data-id="element-187">
            <h3 className="text-2xl md:text-3xl font-bold text-center mb-2" data-id="element-188">
              Herramientas de integración
            </h3>
            <p className="text-brand-gray text-center mb-10" data-id="element-189">
              Incluidas con la Saga 1 y el Megapack
            </p>

            <div className="grid md:grid-cols-3 gap-8" data-id="element-190">
              {[{
              title: 'ESTO ES EL TDAH',
              subtitle: 'Lo que nadie te explicó sobre tu cerebro.',
              desc: 'Los 3 perfiles reales del TDAH aplicados al emprendimiento. Los 4 detonantes principales. Mapa de estados ON/MEDIO/OFF. Plan de 7 días para arrancar.',
              val: '19,97€',
              img: 'https://cdn.magicpatterns.com/uploads/6mqGkSGRzK44TvZeHFxrsQ/B1.png'
            }, {
              title: 'CUADERNO DE INTEGRACIÓN',
              subtitle: '7 minutos al día para consolidar tu sistema.',
              desc: 'Convierte los 5 tomos de la Saga 1 en un hábito diario. Una página por día. 21 micro-enfoques diferentes. Sin teoría, solo integración real.',
              val: '14,97€',
              img: 'https://cdn.magicpatterns.com/uploads/7YzwMMJnVREupV9Xbja4v4/B2.png'
            }, {
              title: 'RITUAL DE REPROGRAMACIÓN',
              subtitle: 'Para volver a ti cuando el día te arrastra.',
              desc: 'Micro-ritual de 7 minutos. Respiración + evidencia de identidad + límite mínimo + acción mínima. Tarjeta imprimible y versión móvil.',
              val: '9,97€',
              img: 'https://cdn.magicpatterns.com/uploads/4kaRiJZjgUdCdiKLS4J69f/B3.png'
            }].map((bono, i) => <div key={i} className="bg-brand-black rounded-2xl overflow-hidden border border-brand-gold/20 flex flex-col" data-id="element-191">
                  <a href={CHECKOUT_23_97} className="block cursor-pointer" data-id="element-192">
                    <img src={bono.img} alt={bono.title} className="w-3/4 mx-auto object-contain py-4 hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width={1024} height={1536} data-id="element-193" />
                  </a>
                  <div className="p-6 flex flex-col flex-grow" data-id="element-194">
                    <div className="text-brand-gold font-bold mb-2" data-id="element-195">
                      Bono #{i + 1}
                    </div>
                    <h4 className="text-xl font-bold text-brand-white mb-2" data-id="element-196">
                      {bono.title}
                    </h4>
                    <p className="text-sm font-bold text-brand-gray mb-4" data-id="element-197">
                      {bono.subtitle}
                    </p>
                    <p className="text-sm text-brand-gray mb-6 flex-grow" data-id="element-198">
                      {bono.desc}
                    </p>
                    <div className="pt-4 border-t border-brand-gold/20 mt-auto" data-id="element-199">
                      <p className="text-sm text-brand-gray line-through" data-id="element-200">
                        Valor real: {bono.val}
                      </p>
                      <p className="text-brand-gold font-bold" data-id="element-201">
                        Incluido GRATIS hoy
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Bonos Saga 2 */}
          <div data-id="element-202">
            <h3 className="text-2xl md:text-3xl font-bold text-center mb-2" data-id="element-203">
              Herramientas de ejecución
            </h3>
            <p className="text-brand-gold text-center mb-10 font-bold" data-id="element-204">
              Incluidas SOLO con el Megapack
            </p>

            <div className="grid md:grid-cols-3 gap-8" data-id="element-205">
              {[{
              title: 'TABLERO ORGANIZACIÓN SEMANAL',
              subtitle: 'Tu semana clara y ejecutable en 5 minutos.',
              desc: 'Plantilla para diseñar tu semana sin planificaciones eternas. Regla de 3 objetivos. Lista NO. Revisión del viernes en 5 preguntas.',
              val: '14,97€',
              img: 'https://cdn.magicpatterns.com/uploads/qf2pwzMxsB3TDwXFewLXgf/B4.png'
            }, {
              title: 'ANTI-DISTRACCIÓN',
              subtitle: 'Entra en foco en 60s. Vuelve en 20s.',
              desc: 'Protocolo para proteger un bloque de trabajo sin fuerza de voluntad. Página A4 imprimible. Lista de fugas. Adaptaciones para casa/coworking.',
              val: '14,97€',
              img: 'https://cdn.magicpatterns.com/uploads/mHvay25w9gGYU6ED3t7t9h/B5.png'
            }, {
              title: 'TRACKER PROYECTOS TERMINADOS',
              subtitle: '30 días para entrenar el hábito de cerrar.',
              desc: 'Tracker visual que convierte terminar en algo que tu cerebro ve y quiere repetir. Archivo de cierres mensual. Protocolo de reinicio.',
              val: '14,97€',
              img: 'https://cdn.magicpatterns.com/uploads/nuRGQFyJ4Sby7m4XsuWNp3/B6.png'
            }].map((bono, i) => <div key={i} className="bg-brand-black rounded-2xl overflow-hidden border border-brand-gold/40 shadow-[0_0_15px_rgba(201,168,76,0.1)] flex flex-col relative" data-id="element-206">
                  <div className="absolute top-4 right-4 bg-brand-gold text-brand-black text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-207">
                    Solo Megapack
                  </div>
                  <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-208">
                    <img src={bono.img} alt={bono.title} className="w-3/4 mx-auto object-contain py-4 hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width={1024} height={1536} data-id="element-209" />
                  </a>
                  <div className="p-6 flex flex-col flex-grow" data-id="element-210">
                    <div className="text-brand-gold font-bold mb-2" data-id="element-211">
                      Bono #{i + 4}
                    </div>
                    <h4 className="text-xl font-bold text-brand-white mb-2" data-id="element-212">
                      {bono.title}
                    </h4>
                    <p className="text-sm font-bold text-brand-gray mb-4" data-id="element-213">
                      {bono.subtitle}
                    </p>
                    <p className="text-sm text-brand-gray mb-6 flex-grow" data-id="element-214">
                      {bono.desc}
                    </p>
                    <div className="pt-4 border-t border-brand-gold/20 mt-auto" data-id="element-215">
                      <p className="text-sm text-brand-gray line-through" data-id="element-216">
                        Valor real: {bono.val}
                      </p>
                      <p className="text-brand-gold font-bold" data-id="element-217">
                        Incluido GRATIS hoy
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="mt-16" data-id="element-218">
            <BuyButtons data-id="element-219" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 10 & 11 — RESUMEN Y PRECIO */}
      <section className="py-24 px-4 bg-brand-black" id="pricing" data-id="element-220">
        <div className="max-w-5xl mx-auto" data-id="element-221">
          <div className="text-center mb-16" data-id="element-222">
            <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-223">
              📦 Elige tu acceso
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-224">
            {/* MEGAPACK CARD */}
            <div className="bg-brand-black p-8 rounded-3xl border-2 border-brand-gold shadow-[0_0_40px_rgba(201,168,76,0.15)] relative transform md:-translate-y-4 flex flex-col h-full" data-id="element-225">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-black font-black px-6 py-2 rounded-full flex items-center gap-2 shadow-lg" data-id="element-226">
                <Star className="w-4 h-4 fill-current" data-id="element-227" />
                MÁS RECOMENDADO
                <Star className="w-4 h-4 fill-current" data-id="element-228" />
              </div>

              <div className="mb-8 mt-4" data-id="element-229">
                <h3 className="text-2xl font-bold text-brand-gold mb-2" data-id="element-230">
                  OPCIÓN COMPLETA
                </h3>
                <div className="text-5xl font-black text-brand-white mb-2" data-id="element-231">
                  23,97€
                </div>
                <p className="text-sm text-brand-gold mb-2" data-id="element-232">
                  Por menos de lo que cuesta una cena, tienes el sistema
                  completo que tu cerebro lleva años necesitando.
                </p>
                <p className="text-brand-gray" data-id="element-233">
                  El sistema completo. De la raíz al resultado.
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-234">
                <li className="flex items-start gap-3 font-bold text-brand-white" data-id="element-235">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-236" />
                  <span data-id="element-237">Todo lo incluido en la Saga 1 +</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-238">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-239" />
                  <span data-id="element-240">Tomo 1: Desintoxicación de Dopamina</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-241">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-242" />
                  <span data-id="element-243">Tomo 2: Sistemas de Disciplina</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-244">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-245" />
                  <span data-id="element-246">Tomo 3: Hiperfoco bajo Demanda</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-247">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-248" />
                  <span data-id="element-249">Tomo 4: Ejecución Imparable</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-250">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-251" />
                  <span data-id="element-252">Tomo 5: Finalización Eficaz</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-253">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-254" />
                  <span data-id="element-255">Bono #4: Tablero Organización Semanal</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-256">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-257" />
                  <span data-id="element-258">Bono #5: Anti-distracción</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-259">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-260" />
                  <span data-id="element-261">Bono #6: Tracker "Proyectos Terminados"</span>
                </li>
              </ul>

              <div className="bg-brand-gold/10 p-4 rounded-xl mb-8 text-center border border-brand-gold/30" data-id="element-262">
                <p className="text-brand-gold font-bold text-lg" data-id="element-263">
                  ✨ Ahorras 265,55€ (92% de descuento)
                </p>
                <p className="text-sm text-brand-gray mt-1" data-id="element-264">
                  Valor total real: 289,52€
                </p>
              </div>

              <a href={CHECKOUT_URL} className="w-full bg-brand-gold hover:bg-yellow-500 text-brand-black font-black text-xl py-5 px-8 rounded-xl shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all transform hover:scale-105 text-center flex flex-col items-center" data-id="element-265">
                <span data-id="element-266">👉 QUIERO EL SISTEMA COMPLETO</span>
                <span className="text-sm font-semibold mt-1 opacity-90" data-id="element-267">
                  10 tomos · 6 bonos · Acceso inmediato
                </span>
              </a>

              <div className="flex items-center justify-center gap-2 mt-4 text-xs text-brand-gray" data-id="element-268">
                <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-269" />
                <span data-id="element-270">
                  Pago 100% seguro · Garantía 30 días · Sin suscripciones
                </span>
              </div>
            </div>

            {/* SAGA 1 CARD */}
            <div className="bg-brand-dark p-8 rounded-3xl border border-brand-gray/30 flex flex-col h-full" data-id="element-271">
              <div className="mb-8" data-id="element-272">
                <h3 className="text-2xl font-bold text-brand-white mb-2" data-id="element-273">
                  OPCIÓN DE ENTRADA
                </h3>
                <div className="text-4xl font-black text-brand-white mb-2" data-id="element-274">
                  14,97€
                </div>
                <p className="text-sm text-brand-gold mb-2" data-id="element-275">
                  El mejor punto de entrada. Los cimientos primero. La ejecución
                  después.
                </p>
                <p className="text-brand-gray" data-id="element-276">
                  Solo la Saga 1. La base. El trabajo interno primero.
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-277">
                <li className="flex items-start gap-3" data-id="element-278">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-279" />
                  <span data-id="element-280">Tomo 1: Identidad sin Límites</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-281">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-282" />
                  <span data-id="element-283">Tomo 2: El Cerebro Anti-Autosabotaje</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-284">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-285" />
                  <span data-id="element-286">Tomo 3: Regulación Emocional</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-287">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-288" />
                  <span data-id="element-289">Tomo 4: Sistema Nervioso y Rendimiento</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-290">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-291" />
                  <span data-id="element-292">Tomo 5: Dopamina Inteligente</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-293">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-294" />
                  <span data-id="element-295">Bono #1: Esto es el TDAH</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-296">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-297" />
                  <span data-id="element-298">Bono #2: Cuaderno de Integración</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-299">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-300" />
                  <span data-id="element-301">Bono #3: Ritual de Reprogramación</span>
                </li>
              </ul>

              <div className="bg-brand-black/50 p-4 rounded-xl mb-8 text-center border border-brand-gold/20" data-id="element-302">
                <p className="text-brand-gold font-bold" data-id="element-303">
                  ✨ Ahorras 129,79€ (90% de descuento)
                </p>
              </div>

              <a href={CHECKOUT_SAGA1} className="w-full border-2 border-brand-gold hover:bg-brand-gold/10 text-brand-gold font-bold text-lg py-4 px-8 rounded-xl transition-all text-center" data-id="element-304">
                → Empezar solo con la Saga 1 — 14,97€
              </a>
              <p className="text-xs text-brand-gray text-center mt-4" data-id="element-305">
                Si después quieres la Saga 2: 14,97€ más. Total: 29,94€.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 12 — HISTORIA Y AUTORIDAD */}
      <section className="py-24 px-4 bg-brand-white text-brand-black" data-id="element-306">
        <div className="max-w-3xl mx-auto" data-id="element-307">
          <h2 className="text-3xl font-black mb-8" data-id="element-308">
            La persona detrás de SIN LÍMITES
          </h2>
          <p className="text-xl font-bold text-brand-gold mb-8" data-id="element-309">
            Liam P. Emprendedor. Diagnosticado con TDAH a los 31.
          </p>

          <div className="space-y-6 text-lg text-gray-800 leading-relaxed" data-id="element-310">
            <p data-id="element-311">
              Cuando recibí el diagnóstico, lo primero que sentí no fue alivio.
            </p>
            <p className="font-bold text-black text-2xl" data-id="element-312">Fue rabia.</p>
            <p data-id="element-313">
              Rabia por los años que perdí culpándome de algo que tenía una
              explicación. Rabia por los sistemas que intenté sin saber que no
              estaban diseñados para mí. Rabia por la energía quemada en
              vergüenza que podría haber ido a construir algo real.
            </p>
            <p data-id="element-314">Y después de la rabia, vino una pregunta:</p>
            <p className="italic text-xl font-bold text-black" data-id="element-315">
              "¿Existe algo diseñado de verdad para un cerebro como el mío?"
            </p>
            <p data-id="element-316">La respuesta era no.</p>
            <p className="font-bold text-brand-gold text-2xl" data-id="element-317">
              Así que lo construí.
            </p>
            <p data-id="element-318">No en teoría. En la práctica real de emprender con TDAH.</p>
            <p data-id="element-319">
              Con años de investigar, probar, fallar y ajustar hasta tener algo
              que funciona de verdad.
            </p>
            <p data-id="element-320">
              SIN LÍMITES no nació para venderse. Nació porque lo necesitaba.
            </p>
            <p className="font-bold text-black text-xl" data-id="element-321">
              Y si estás leyendo esto, probablemente tú también.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 13 — TESTIMONIOS */}
      <section className="py-24 px-4 bg-brand-dark" data-id="element-322">
        <div className="max-w-6xl mx-auto" data-id="element-323">
          <h2 className="text-3xl md:text-5xl font-black mb-16 text-center" data-id="element-324">
            Lo que dicen quienes ya están dentro
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-325">
            {[{
            text: 'Llevaba 4 años intentando arrancar mi agencia de verdad. Siempre lo mismo: empezaba con todo, me bloqueaba, lo dejaba. La primera semana con la Saga 1 entendí por qué pasaba. Esa misma semana cerré 2 clientes nuevos.',
            name: 'Alejandro M.',
            age: '34 años',
            role: 'Agencia de contenido',
            city: 'Madrid'
          }, {
            text: 'Antes entraba en hiperfoco siempre en lo que no tocaba. Con el Tomo 3 de la Saga 2 aprendí a activarlo cuando importa. Terminé un proyecto que llevaba 5 meses al 90%. En 3 bloques de 60 minutos.',
            name: 'Carmen R.',
            age: '29 años',
            role: 'Diseñadora UX',
            city: 'Barcelona'
          }, {
            text: 'Lo que más me sorprendió fue empezar por dentro. Nunca pensé que la Saga 1 tuviera tanto impacto. Cuando llegué a la Saga 2, los sistemas se instalaron solos. Por fin entiendo por qué los otros métodos no me duraban.',
            name: 'Sofía L.',
            age: '38 años',
            role: 'E-commerce',
            city: 'Valencia'
          }, {
            text: 'Llevo 7 semanas con el ciclo semanal de la Saga 2 y es la primera vez en mi vida que termino lo que empiezo de forma consistente. Mi negocio avanzó más en 7 semanas que en el año anterior.',
            name: 'Pablo G.',
            age: '42 años',
            role: 'Agencia de marketing',
            city: 'Sevilla'
          }, {
            text: 'El Tomo 2 de la Saga 1 me cambió la perspectiva. Nunca había entendido por qué me saboteaba justo cuando más cerca estaba. Ahora tengo el mapa de mis patrones y un protocolo para cuando aparecen. Por primera vez siento que puedo contar conmigo mismo.',
            name: 'Natalia F.',
            age: '32 años',
            role: 'Consultora de marca',
            city: 'Bilbao'
          }, {
            text: 'Por 14,97€ pensé que era otro PDF genérico. Me equivoqué completamente. Lo abrí el lunes. El miércoles ya había terminado algo que llevaba semanas bloqueado. Vale diez veces más de lo que pagué.',
            name: 'Marcos V.',
            age: '36 años',
            role: 'Desarrollador freelance',
            city: 'Zaragoza'
          }].map((testimonial, i) => <div key={i} className="bg-brand-black p-8 rounded-2xl border border-brand-gold/20 flex flex-col" data-id="element-326">
                <div className="flex gap-1 mb-4" data-id="element-327">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 text-brand-gold fill-current" data-id="element-328" />)}
                </div>
                <p className="text-brand-white italic mb-6 flex-grow" data-id="element-329">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-brand-gold/20 pt-4" data-id="element-330">
                  <p className="font-bold text-brand-gold" data-id="element-331">
                    {testimonial.name} · {testimonial.age}
                  </p>
                  <p className="text-sm text-brand-gray" data-id="element-332">
                    {testimonial.role} · {testimonial.city}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* INSERCIÓN #4 — Transición testimonios → garantía */}
      <section className="py-16 px-4 bg-brand-dark text-center" data-id="element-333">
        <div className="max-w-3xl mx-auto" data-id="element-334">
          <p className="text-xl md:text-2xl text-brand-white font-bold leading-relaxed" data-id="element-335">
            Personas reales. Negocios reales.
          </p>
          <p className="text-lg text-brand-gray mt-4 leading-relaxed" data-id="element-336">
            El mismo sistema. El mismo cerebro que tú tienes.
            <br data-id="element-337" />
            <br data-id="element-338" />
            La única diferencia entre ellos
            <br data-id="element-339" />
            y donde estás tú ahora mismo
            <br data-id="element-340" />
            <span className="text-brand-gold font-bold" data-id="element-341">
              es que ellos tomaron la decisión.
            </span>
          </p>
        </div>
      </section>

      {/* SECCIÓN 14 — GARANTÍA */}
      <section className="py-24 px-4 bg-brand-black text-center" data-id="element-342">
        <div className="max-w-3xl mx-auto" data-id="element-343">
          <ShieldCheck className="w-24 h-24 text-brand-gold mx-auto mb-8" data-id="element-344" />
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-345">
            🛡️ Pruébalo 30 días.
            <br data-id="element-346" />
            <span className="text-brand-gold" data-id="element-347">Sin riesgo. Sin drama.</span>
          </h2>

          <div className="text-lg md:text-xl text-brand-gray space-y-6" data-id="element-348">
            <p data-id="element-349">Aplica al menos un tomo siguiendo todos los pasos.</p>
            <p className="text-brand-white font-bold text-2xl" data-id="element-350">
              Si en 30 días sientes que el sistema no aportó valor real a la
              forma en que funciona tu negocio: Te devolvemos el 100% del
              dinero.
            </p>
            <p data-id="element-351">
              Un email es suficiente. Sin formularios. Sin justificaciones. Sin
              condiciones.
            </p>
            <p data-id="element-352">
              La garantía existe porque confío en el sistema. Y porque 14,97€ o
              23,97€ no deberían ser nunca la razón para no acceder a algo que
              puede cambiar cómo funciona tu negocio.
            </p>
            <p className="text-brand-gold font-bold text-2xl mt-8" data-id="element-353">
              El único riesgo real es seguir sin el sistema.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 15 — FAQ */}
      <section className="py-24 px-4 bg-brand-dark" data-id="element-354">
        <div className="max-w-3xl mx-auto" data-id="element-355">
          <h2 className="text-3xl md:text-5xl font-black mb-12 text-center" data-id="element-356">
            ❓ Preguntas frecuentes
          </h2>

          <div className="bg-brand-black rounded-2xl p-6 md:p-8 border border-brand-gold/20" data-id="element-357">
            <FAQItem question="¿Necesito tener TDAH diagnosticado?" answer="No. Si te reconociste en la descripción del problema, el sistema funciona para ti. El diagnóstico formal no es requisito." data-id="element-358" />
            <FAQItem question="¿Cómo recibo el material?" answer="Acceso inmediato tras la compra. Descarga directa en PDF. Sin plataformas. Sin contraseñas. Tuyo para siempre." data-id="element-359" />
            <FAQItem question="¿Por qué la Saga 1 va antes que la Saga 2?" answer={<>
                  <p data-id="element-361">
                    Porque instalar sistemas de productividad sobre un sistema
                    interno inestable produce sistemas que duran 2 semanas. Lo
                    has vivido.
                  </p>
                  <p data-id="element-362">
                    La Saga 1 trabaja los cimientos internos. La Saga 2
                    construye la estructura de ejecución sobre esa base. Ese
                    orden es lo que lo hace sostenible.
                  </p>
                </>} data-id="element-360" />
            <FAQItem question="¿Tengo que leer los 10 tomos a la vez?" answer="No. Empiezas con el Tomo 1 de la Saga 1 y avanzas a tu ritmo. Cada tomo construye sobre el anterior. El primer bloque empieza con 20 minutos." data-id="element-363" />
            <FAQItem question="¿Puedo comprar la Saga 1 ahora y la Saga 2 después?" answer={<>
                  <p data-id="element-365">
                    Sí. Puedes empezar con la Saga 1 por 14,97€. Si después
                    quieres la Saga 2, serán 14,97€ más. Total: 29,94€.
                  </p>
                  <p data-id="element-366">
                    El Megapack hoy cuesta 23,97€. Si sabes que querrás las dos,
                    el Megapack te ahorra 6€ y te da acceso a todo ahora.
                  </p>
                </>} data-id="element-364" />
            <FAQItem question="¿Tiene base científica?" answer={<>
                  <p data-id="element-368">
                    Sí. Cada protocolo está construido sobre neurociencia del
                    TDAH, investigación sobre dopamina y principios de
                    neuroplasticidad aplicados al rendimiento.
                  </p>
                  <p data-id="element-369">
                    No es motivación abstracta. Es ciencia aplicada a tu
                    cerebro.
                  </p>
                </>} data-id="element-367" />
            <FAQItem question="¿Y si no funciona para mí?" answer="Garantía de 30 días sin preguntas. Un email es suficiente para la devolución completa. Sin condiciones." data-id="element-370" />
            <FAQItem question="¿Es un sustituto de tratamiento médico o terapia?" answer="No. SIN LÍMITES es psicoeducación y desarrollo personal. Complementa cualquier tratamiento o terapia. No los reemplaza." data-id="element-371" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 16 — CTA FINAL */}
      <section className="py-32 px-4 bg-brand-black text-center relative overflow-hidden" data-id="element-372">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-373"></div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-374">
          <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight" data-id="element-375">
            Hay dos versiones de ti
            <br data-id="element-376" />
            <span className="text-brand-gold" data-id="element-377">leyendo esto ahora mismo.</span>
          </h2>

          <div className="text-lg md:text-xl text-brand-gray space-y-6 mb-12" data-id="element-378">
            <p data-id="element-379">
              La primera va a cerrar esta página y seguir con los mismos
              métodos.
            </p>
            <p data-id="element-380">
              Seguirá con los proyectos al 80%. Con las semanas que se repiten.
              Con la sensación de que podría dar más si consiguiera simplemente
              funcionar.
            </p>
            <p data-id="element-381">
              Y dentro de un mes estará en la misma posición. Preguntándose lo
              mismo.
            </p>

            <p className="text-brand-white font-bold text-2xl mt-12" data-id="element-382">
              La segunda decide hoy que ya es suficiente.
            </p>

            <p data-id="element-383">
              Que ya basta de usar herramientas diseñadas para otro cerebro. Que
              ya basta de culparse por algo que tiene solución. Que ya es el
              momento de tener el sistema correcto.
            </p>

            <p className="text-brand-gold font-black text-3xl mt-12" data-id="element-384">
              Tu cerebro no necesita arreglarse.
            </p>
            <p className="text-brand-white font-bold text-2xl" data-id="element-385">
              Necesita las herramientas correctas.
            </p>

            <p className="mt-8" data-id="element-386">
              Hoy están disponibles por menos de lo que cuesta una cena.
            </p>
            <p className="text-2xl font-bold text-brand-white" data-id="element-387">
              ¿Cuántas semanas más vas a esperar para tenerlas?
            </p>
          </div>

          <BuyButtons data-id="element-388" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 px-4 bg-brand-dark text-center text-sm text-brand-gray border-t border-brand-gold/10" data-id="element-389">
        <p className="mb-2" data-id="element-390">
          © SIN LÍMITES — TDAH para Emprendedores · Liam P.
        </p>
        <p className="text-xs opacity-70" data-id="element-391">
          Este producto no sustituye diagnóstico ni tratamiento médico
          profesional.
        </p>
      </footer>
    </div>;
}